import { graphql } from "react-relay";

export const DeployBindingMutation = graphql`
  mutation DeployBindingMutation($uuid: String!) {
    deployBinding(uuid: $uuid) {
      binding {
        deployment {
          percentageDeployed
        }
        lastDeployed
        name
        uuid
      }
    }
  }
`;
